
import { typeHandoverRecordFilters } from './dHandoverRecordReducer'
import { typeRequestPagination } from '../system/constants'
import { apiClient } from 'model/axiosConfig';

export type typeHRecordsRequestFilters = {
    filters: {
        pos?: {
            posNumber?: number,
            store?: { name: string[]  }
        } | null,

        closeDate?: {
            from: string,
            to: string,
        } | {},
    },
    full?: boolean,
    pageFilter: typeRequestPagination
    sortFilter: {
        direction: string,
        column: string
    }
}

// Get HandoverReports
export const getHandoverRecordsList = async (payload: {  filters: typeHandoverRecordFilters, paginationRequest: typeRequestPagination }) => {

    const path = '/product/pos/transfer/search'
    const config = {
        headers: {},
    }
    const data: typeHRecordsRequestFilters = {
        filters: {},
        full: true,
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: 'DESC',
            column: 'closeDate'
        }
    }

    if (payload.filters.storeName) {
        data.filters.pos={store: {name: [ payload.filters.storeName ] }}
    }
    if (payload.filters.posNumber) {
        data.filters.pos= {...data.filters.pos, posNumber: +payload.filters.posNumber }
    }

    if (payload.filters.closeDate) data.filters.closeDate = payload.filters.closeDate


    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error
    }
}
